<script setup>
import { ref, shallowRef, onMounted } from 'vue'
import HeaderOverlaySearch from './HeaderOverlaySearch.vue'
import HeaderOverlayMenu from './HeaderOverlayMenu.vue'
import HeaderSearchResults from './HeaderSearchResults.vue'

defineProps({
  isOverlayMenuShow: { type: Boolean, default: false },
  isOverlaySearchShow: { type: Boolean, default: false },
  devDomains: { type: Object, default: () => {} }
})
const emit = defineEmits(['close'])
const close = () => {
  emit('close')
}
const searchResults = shallowRef([])
const isShow = ref(false)

onMounted(() => {
  isShow.value = window.innerWidth < 768
})

</script>

<template>
  <section
    id="headerOverlay"
    class="headerOverlay"
    @click.self="close"
  >
    <section class="headerOverlay__content">
      <div
        id="overlayCloseBtn"
        class="closeButton"
        @click="close"
      >
        <span />
      </div>
      <div class="headerOverlay__wrap">
        <HeaderOverlaySearch
          v-if="isOverlaySearchShow"
          v-model:search-results="searchResults"
        />
        <HeaderSearchResults
          :search-results="searchResults"
          :is-show="isShow"
        />
        <HeaderOverlayMenu
          v-if="isOverlayMenuShow"
          :dev-domains="devDomains"
        />
      </div>
    </section>
  </section>
</template>

<style lang="scss" scoped>
.headerOverlay {
  z-index: 100;
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.15);
}

.headerOverlay__content {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column;
  gap: 5px;
  -webkit-transform: translateX(-50%);
  -webkit-box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.25);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  z-index: 9;
  position: absolute;
  top: 10px;
  left: 50%;
  flex-flow: column;
  width: 95%;
  max-width: 500px;
  max-height: 90vh;
  padding: 10px;
  transform: translateX(-50%);
  border-radius: 12px;
  background-color: #fff;
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.25);
}

.headerOverlay__wrap {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column;
  gap: 10px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  flex: 1;
  flex-flow: column;
  padding: 0px 10px 0px 0px;
  overflow-y: scroll;
}

.headerOverlay .closeButton {
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  border: 2px solid #ffffff;
  border-radius: 100px;
  background: -webkit-gradient(linear, left top, left bottom, from(#606060), to(#323232));
  background: linear-gradient(180deg, #606060 0%, #323232 100%);
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
}

.headerOverlay .closeButton > * {
  position: relative;
  width: 30px;
  height: 30px;
}

.headerOverlay .closeButton > *:before,
.headerOverlay .closeButton > *:after {
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 2px;
  height: 50%;
  background-color: #fff;
  content: '';
}

.headerOverlay .closeButton > *::before {
  -webkit-transform: translate(-50%, -50%) rotate(-45deg);
  transform: translate(-50%, -50%) rotate(-45deg);
}

.headerOverlay .closeButton > *::after {
  -webkit-transform: translate(-50%, -50%) rotate(45deg);
  transform: translate(-50%, -50%) rotate(45deg);
}

</style>
